import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axiosInstance from '../interceptor/intercetptor-inctence';
import { useLab } from '../_helper/PharmacyProvider';
import { toast } from 'react-toastify';
import { useLicense } from '../_helper/LicenseContext';
import { useLoader } from '../_helper/LoaderContext';
import { withLoginTax } from '../utils/taxConfig';

const SSOHandler = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { setCurrentLab } = useLab();
    const { saveLicenseToken, decodeJWT } = useLicense();
    const { setLoading } = useLoader();
    const history = useNavigate();

    useEffect(() => {
        const token = searchParams.get('token');

        if (token) {
            handleSSOLogin(token);
        }
    }, [searchParams]);

    const handleSSOLogin = async (ssoToken) => {
        try {
            setLoading(true);
            const response = await axiosInstance.post('api/lab-user/sso-login', {
                token: ssoToken
            });

            if (response.data.success === true) {
                const loggedInUser = withLoginTax(response.data.data.healthCareProvider, response.data.data);
                console.log(loggedInUser)
                const serverLicenseToken = loggedInUser.licenseToken;
                localStorage.setItem('currentLab', JSON.stringify(loggedInUser));
                localStorage.setItem('currentLabAuth', response.data.data.token);
                const headerFooter = {
                    headerTest: response.data.data.healthCareProvider.settings.headerText,
                    footerText: response.data.data.healthCareProvider.settings.footerText,
                    headerLogo: response.data.data.healthCareProvider.settings.headerLogo
                }
                localStorage.setItem("header", JSON.stringify(headerFooter));
                localStorage.setItem("licenseKey", loggedInUser.licenseKey)
                setCurrentLab(loggedInUser);
                if (loggedInUser.licenseToken !== null) {
                    if (serverLicenseToken) {
                        await saveLicenseToken(serverLicenseToken);
                        const decoded = await decodeJWT(serverLicenseToken);
                        const isAllowedUser = decoded?.users?.some(
                            (user) => user.id === loggedInUser._id
                        );

                        if (isAllowedUser) {
                            history(`${process.env.PUBLIC_URL}/dashboard`, { replace: true });
                            return;
                        } else {
                            toast.warning('User is not registered with us. Please contact the ClinicDots admin.');
                            history(`${process.env.PUBLIC_URL}/login`, { replace: true });
                            localStorage.clear();
                        }
                    }
                }
                else {
                    history(`${process.env.PUBLIC_URL}/activate`);
                }
            }
        } catch (error) {
            console.error('SSO Login Error:', error);
            // toast.warning(error.message || 'SSO Login failed');
            navigate(`${process.env.PUBLIC_URL}/login`, { replace: true });
        } finally {
            setLoading(false);
        }
    };

    return null; // This component doesn't render anything visible
};

export default SSOHandler;
